export const isOtherPartyConfidential = (userRole, partyHiddenFrom) => {
  if (userRole === 'buyer' && 'seller' in partyHiddenFrom) {
    return partyHiddenFrom.seller.includes(userRole);
  } else if (userRole === 'seller' && 'buyer' in partyHiddenFrom) {
    return partyHiddenFrom.buyer.includes(userRole);
  }
  return false;
};

export const isTransparentToBothParties = (partyHiddenFrom) => partyHiddenFrom && Object.keys(partyHiddenFrom).length === 0;
